import { CListGroup, CListGroupItem, CBadge } from "@coreui/react";

const Details = ({ editedDesc, editedFiles, isCurated }) => {
    return (
        <div style={{ overflow: "hidden" }}>
            <div style={{ width: "90%", marginBottom: "3rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
                <h5>Description:</h5>
                <p>{editedDesc}</p>
                {!isCurated && <CBadge
                    shape="rounded-pill"
                    style={{
                        backgroundColor: 'rgba(255, 191, 0, 0.2)',
                        color: '#ffbf00',
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        padding: '0.35rem 0.75rem',
                        width: "fit-content"
                    }}
                >
                    Please verify minimum of 30 responses and hit "Generate Report" to begin generating reports
                </CBadge>}
            </div>
            <div style={{ width: "50%", marginTop: "1rem" }}>
                <h5 >Supporting Documents:</h5>
                <CListGroup>
                    {editedFiles.map((file, index) => {
                        const fileExtension = file.key.split('.').pop();
                        return (
                            <CListGroupItem
                                key={index}
                                style={{ display: 'flex', alignItems: 'center', padding: 10, width: '30rem', border: '1px solid var(--primary-light-bg)' }}
                                className="mb-2"
                            >
                                <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ marginRight: 5, flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {file.key}
                                </a>
                                <span style={{ color: '#6c757d', flexShrink: 0 }}>({fileExtension})</span>
                            </CListGroupItem>
                        );
                    })}
                </CListGroup>
            </div>
        </div>
    );
}

export default Details;
